/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import './fonts.css';
import { getAppState } from '@completeanatomy/common';
import { router } from './router';
import { useConfigService } from '@completeanatomy/config';
import { globalVariables } from './config/globalVariables';
import { useAnalyticsService } from '@completeanatomy/analytics';
import { getOneTrustActiveGroupsIds } from './utils/cookies/getOneTrustActiveGroupsIds';
import { clearRevokedCookies } from './utils/cookies/clearRevokedCookies';

function App() {
  const config = useConfigService();
  const analyticsService = useAnalyticsService();

  useEffect(() => {
    config?.set('pendoApiKey', globalVariables.pendoApiKey);

    const onOneTrustGroupsUpdated = async () => {
      const activeGroups = getOneTrustActiveGroupsIds();
      const analyticsCookieAccepted = activeGroups.includes('2');

      if (analyticsCookieAccepted) {
        await analyticsService.initialize();
      } else {
        analyticsService.teardown();
      }

      clearRevokedCookies();
    };

    onOneTrustGroupsUpdated();

    window.addEventListener('OneTrustGroupsUpdated', onOneTrustGroupsUpdated);

    return () => {
      window.removeEventListener(
        'OneTrustGroupsUpdated',
        onOneTrustGroupsUpdated
      );
    };
  }, []);

  return <RouterProvider router={router} />;
}

//@ts-ignore
window.getAppState = () => {
  console.log(getAppState());
};

export default App;
